module.exports = __webpack_public_path__ + "_assets/img/Frame1208.2b3c9ac8.svg";